import React from 'react';
import { Plug } from 'lucide-react';

// Clio is a secondary path: Sortio files into folders on its own, and the
// Clio integration (Pro) is for firms that keep documents in Clio Manage.
// Facts (app v8.63, src-tauri/src/clio): open matters come from the Clio
// API; matching ranks candidate matters per file and the preview defaults
// low-confidence files to skip; approved files upload from the desktop app
// straight to Clio, with a local upload record.
const ClioIntegration = () => {
  return (
    <section id="clio" className="my-16 sm:my-20 scroll-mt-24">
      <div className="text-center mb-10">
        <div className="inline-block mb-4">
          <div className="flex items-center justify-center px-4 py-1.5 rounded-full bg-sortio-primary/10 border border-sortio-primary/20">
            <Plug className="mr-2 text-sortio-primary" size={14} aria-hidden="true" />
            <span className="text-xs font-medium uppercase tracking-wider text-sortio-primary">
              Integration
            </span>
          </div>
        </div>
        <h2 className="text-3xl sm:text-4xl font-semibold mb-4 tracking-tight text-apple-50">
          Use Clio? Send filed documents to the right Clio matter
        </h2>
        <p className="text-apple-300 text-lg font-light max-w-2xl mx-auto">
          You don&apos;t need Clio to use Sortio. If your firm keeps documents in Clio Manage, Sortio
          can put them there too.
        </p>
      </div>

      <div className="bg-apple-800/40 backdrop-blur-sm rounded-2xl border border-apple-700/50 p-6 sm:p-10 max-w-3xl mx-auto">
        <p className="text-apple-200 text-base sm:text-lg leading-relaxed">
          Connect Clio Manage in Settings. Sortio pulls your open matters through the official Clio
          API, suggests a matter and a clean document name for each file, and shows you the plan.
          Files it isn&apos;t confident about are left unselected for you to decide. Only the files
          you approve are uploaded, from your computer straight to that matter&apos;s documents in
          Clio. The Clio integration is included with Pro.
        </p>
        <p className="text-apple-200 text-base sm:text-lg leading-relaxed mt-4">
          <a
            href="https://www.clio.com/app-directory/sortio/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sortio-primary hover:underline font-medium"
          >
            Find Sortio in the Clio App Directory →
          </a>
        </p>
      </div>
    </section>
  );
};

export default ClioIntegration;
